<template>
  <div class="overflow-auto">
    <div class="wrapper">
      <div v-if="showHeader && headerData" class="header">
        <h1 v-if="headerData.title" class="title">
          {{ headerData.title }}
        </h1>

        <div class="main">
          <img :src="headerData.logo" alt="logo" class="logo" />
          <div v-if="headerData.info && headerData.info.length" class="data">
            <div
              v-for="(item, index) in headerData.info"
              :key="`info-${item.label || index}`"
              class="info"
            >
              <p class="label">{{ item.label || "" }}</p>
              <p class="value">{{ item.value || "" }}</p>
            </div>
          </div>
        </div>
      </div>

      <div v-if="sections && sections.length" class="content">
        <div
          v-for="(section, sectionIndex) in sections"
          :key="`section-${section.title || sectionIndex}`"
          class="section"
        >
          <h3 v-if="section.title" class="name">
            {{ section.title }}
          </h3>
          <div
            v-for="(item, itemIndex) in section.items"
            :key="`item-${item.label || itemIndex}`"
            class="item"
          >
            <p v-if="item.label" class="label">{{ item.label }}</p>
            <div v-if="item.values && item.values.length" class="values">
              <div
                v-for="(langItem, langIndex) in item.values"
                :key="`lang-${langItem.lang || langIndex}`"
                class="value"
              >
                <span v-if="langItem.lang" class="lang">{{
                  $t(langItem.lang)
                }}</span>
                <p v-if="langItem.text" class="text">{{ langItem.text }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InformationLayout",
  props: {
    showHeader: {
      type: Boolean,
      default: true,
    },
    headerData: {
      type: Object,
      default: () => ({
        title: "",
        logo: "",
        info: [],
      }),
    },
    sections: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
<style scoped lang="scss">
.wrapper {
  @apply w-full h-full flex flex-col items-start gap-12;
  flex: 1 0 0;
  //border-radius: 20px;
  //box-shadow: 0 1px 1px -0.5px rgba(0, 0, 0, 0.03),
  //  0 3px 3px -1.5px rgba(0, 0, 0, 0.03), 0 20px 20px -12px rgba(0, 0, 0, 0.03);
  .header {
    @apply flex flex-col items-start gap-6 self-stretch;

    .title {
      @apply flex items-center text-lg leading-6 font-semibold text-foreground;
    }

    .main {
      @apply flex p-4 items-center gap-4 self-stretch rounded-2xl bg-muted;

      .logo {
        @apply w-20 h-20 rounded-xl shrink-0;
      }

      .data {
        @apply flex flex-1 flex-col items-start gap-2;

        .info {
          @apply flex flex-col justify-center items-start self-stretch;

          .label {
            @apply flex items-center self-stretch text-xs text-muted-foreground;
          }

          .value {
            @apply flex items-center self-stretch text-base leading-5 text-foreground;
          }
        }
      }
    }
  }
  .content {
    @apply flex flex-col items-start gap-8 self-stretch;

    .section {
      @apply flex flex-col items-start gap-4 self-stretch;

      .name {
        @apply w-full flex items-center pb-4 text-lg leading-6 font-semibold text-foreground;
        border-bottom: 1px solid hsl(var(--border));
      }

      .item {
        @apply w-full flex items-start pb-4 gap-8 self-stretch;
        border-bottom: 1px solid hsl(var(--border));

        .label {
          @apply w-1/2 min-w-[70px] max-w-[360px] text-sm text-muted-foreground;
        }

        .values {
          @apply w-1/2 flex flex-col justify-center items-start gap-4;

          .value {
            @apply flex justify-center items-center gap-2;
            @media (max-width: 750px) {
              @apply flex-col items-start;
            }

            .lang {
              @apply flex justify-center items-center py-1 px-3 text-xs rounded-[18px] bg-muted;
              @apply font-bold text-muted-foreground;
            }

            .text {
              @apply text-sm font-medium text-foreground;
            }
          }
        }
      }
    }
  }
}
</style>
